import { useState } from "react";
import "../styles/main.css";

function Contact() {

  // ✅ AUTO SWITCH (LOCAL + HOSTING)
 
  const API_URL = process.env.REACT_APP_API_URL;

  // STATE
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: ""
  });

  // HANDLE CHANGE
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // HANDLE SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_URL}/api/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      const data = await res.json();

      if (data.status === "success") {
        alert("✅ Message Sent Successfully!");

        // RESET FORM
        setFormData({
          fullName: "",
          email: "",
          subject: "",
          message: ""
        });

      } else {
        alert("❌ Error sending message");
      }

    } catch (error) {
      console.error("Error:", error);
      alert("❌ Cannot connect to server");
    }
  };

  return (
    <div className="contact">

      <h2 className="contact-title">Contact Us</h2>

      <div className="contact-container">

        {/* LEFT SIDE */}
        <div className="contact-left">

          <h3>Reach Out to Us</h3>

          <p>
            Have questions about admissions, courses, or facilities?
            Our team is here to help you.
          </p>

          <div className="contact-info">
            <p><b>📍 Location</b><br />
              Bhavsingpura, Chh. Sambhajinagar
            </p>

            <p><b>📞 Phone</b><br />
              9595302222, 9404677689
            </p>

            <p><b>✉ Email</b><br />
              tejkirticollege584@gmail.com
            </p>

            <p><b>🕒 Hours</b><br />
              Mon–Sat: 10 AM – 5 PM
            </p>
          </div>

          <div className="contact-buttons">
            <a href="tel:9595302222" className="btn-call">Call Now</a>

            <a
              href="https://wa.me/919595302222"
              target="_blank"
              rel="noreferrer"
              className="btn-whatsapp"
            >
              WhatsApp
            </a>
          </div>

          {/* MAP */}
          <div className="map">
            <iframe
              title="college-location"
              src="https://maps.google.com/maps?q=Bhavsingpura%20Chhatrapati%20Sambhajinagar&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="250"
              style={{ border: 0, borderRadius: "10px", marginTop: "20px" }}
              loading="lazy"
            ></iframe>
          </div>

        </div>

        {/* RIGHT FORM */}
        <div className="contact-right">

          <h3>Send Us a Message</h3>

          <form className="contact-form" onSubmit={handleSubmit}>

            <div className="form-group">
              <label>Full Name</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Subject</label>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                required
              ></textarea>
            </div>

            <button type="submit">Send Message</button>

          </form>

        </div>

      </div>

    </div>
  );
}

export default Contact;